import React from "react";
import { ReactComponent as BoxCircleCheck } from "assets/svgs/box-circle-check.svg";
import { ReactComponent as BoxCircleX } from "assets/svgs/box-circle-x.svg";
import { ReactComponent as Headset } from "assets/svgs/headset.svg";

const StockStatus = ({ isAvailable, preorder }) => (
	<span className="text-sm font-bold">
		{preorder ? "Pre-Order" : isAvailable ? "In Stock" : "Out of Stock"}
	</span>
);

const InfoContainer = ({ children }) => (
	<div className="flex items-center gap-2 md:bg-[#E0E0E04D] md:p-2 px-6 md:px-2 w-full xl:min-w-fit justify-center">
		{children}
	</div>
);

const DeliveryInfo = ({ logistics, availabilityDetails }) => {
	const { hideServicesInfo = false } = logistics || {};
	const { to: shipmentTo } = logistics?.shipment || {};
	const { from: deliveryFrom, to: deliveryTo } = logistics?.delivery || {};
	const { preorder, shippingTime, isAvailable } = availabilityDetails || {};

	const hasDeliveryInfo = shipmentTo && deliveryFrom && deliveryTo;
	const isAvailableForDelivery = isAvailable && !preorder && hasDeliveryInfo && !hideServicesInfo;

	return (
		<InfoContainer>
			<span className="w-fit">
				{isAvailable ? <BoxCircleCheck /> : <BoxCircleX />}
			</span>
			<div className="flex gap-x-2 flex-wrap">
				<StockStatus isAvailable={isAvailable} preorder={preorder} />
				{isAvailableForDelivery &&
					<p className="text-sm">Delivers in {shipmentTo + deliveryFrom}-{shipmentTo + deliveryTo} days</p>
				}
				{preorder && shippingTime && <p className="text-sm">{shippingTime}</p>}
			</div>
		</InfoContainer>
	);
};

const CustomerServiceInfo = () => (
	<InfoContainer>
		<span className="w-fit">
			<Headset />
		</span>
		<p className="text-sm">24/7 Customer Service</p>
	</InfoContainer>
);

const ServiceInfo = ({ logistics, variant }) => (
	<div className="flex flex-col gap-6">
		<div className="flex flex-col md:flex-row gap-2 mx-auto items-center w-full bg-[#E0E0E04D] md:bg-transparent py-2.5 md:py-0">
			<DeliveryInfo logistics={logistics} availabilityDetails={{ ...variant.availability, isAvailable: variant?.isAvailable }} />
			<CustomerServiceInfo />
		</div>
	</div>
);

export default ServiceInfo;